<style>
.contract-name {
  display: block;
  width: 120px;
  text-align: right;
  margin-right: 20px;
  flex-shrink: 0;
}
.contract-item {
  display: flex;
  text-align: left;
  margin-bottom: 20px;
}
.checkPdf {
  cursor: pointer;
  color: #4fa1a4;
}
.el-dialog-div {
  height: 80vh;
}
</style>
<template>
  <div>
    <el-drawer title="合同详情" :visible.sync="showContractDetail" :direction="direction" size="35%">
      <div class="t-left">
        <div class="contract-item">
          <span class="contract-name">付款单位：</span>
          <span class="contract-content">{{ contractData.payeeName }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">发票类型：</span>
          <span class="contract-content">{{ contractData.invoiceType | getInvoiceType }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">是否先开票：</span>
          <span class="contract-content">{{ contractData.isInvoiceFirst | getIsInvoiceFirst }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">纳税人识别号：</span>
          <span class="contract-content">{{ contractData.invoiceTaxpayerId }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">开户行：</span>
          <span class="contract-content">{{ contractData.bank }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">银行账号：</span>
          <span class="contract-content">{{ contractData.bankAccount }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">地址：</span>
          <span class="contract-content">{{ contractData.address }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">电话：</span>
          <span class="contract-content">{{ contractData.contactTel }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">邮寄地址：</span>
          <span class="contract-content">{{ contractData.mailAddress }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">收件人：</span>
          <span class="contract-content">{{ contractData.recipient }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">收件人联系电话：</span>
          <span class="contract-content">{{ contractData.recipientTel }}</span>
        </div>
        <div class="contract-item">
          <span class="contract-name">电子邮箱：</span>
          <span class="contract-content">{{ contractData.email }}</span>
        </div>
      </div>
      <div class="contract-table mt50 mb30">
        <el-table :data="mfContractDetails" style="width: 100%" border>
          <el-table-column prop="contractNo" label="合同编号" width="110" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="startDate" label="合同开始时间" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.startDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endDate" label="合同结束时间" header-align="center" align="center"> 
            <template slot-scope="scope">
              <span>{{ scope.row.endDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pdfName" label="合同扫描件（pdf）" width="110" header-align="center" align="center">
            <template slot-scope="scope">
              <div :class="scope.row.scanCopy ? 'checkPdf' : ''" @click="getPdf(scope.row)">
                {{ scope.row.scanCopy ? '点击查看' : '暂无附件' }}
              </div>
              <!-- <div class="checkPdf" @click="getPdf(scope.row)">点击查看</div> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <el-dialog
      title="PDF查看"
      :visible.sync="getPdfFile"
      fullscreen
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="el-dialog-div">
        <iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['contractDetailData'],
  data() {
    return {
      showContractDetail: false,
      getPdfFile: false,
      pdfSrc: '',
      tableData1: [
       
      ],
      contractData: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      direction: 'rtl',
      mfContractDetails: [],
    };
  },
  created() {
    // this.getContractData();
  },
  methods: {
    //获取合同信息
    getContractData(supplierGuid) {
      let self = this;
      self.api
        .get(`/ms-data-business-service/contract-detail/get-contract-info?supplierGuid=` + supplierGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.contractData = res.data.data;
            // 给合同详情赋值
            self.mfContractDetails = res.data.data.mfContractDetails;
            if (res.data.data.mfContractDetails) {
              self.mfContractDetails.forEach((item) => {
                item.scanCopy = JSON.parse(item.scanCopy);
              });
            }
            console.log(res.data);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //点击查看pdf
    getPdf(row) {
      let self = this;
      if (!row.scanCopy) {
        return;
      }
      self.getPdfFile = true;
      if (self.mfContractDetails == '' || self.mfContractDetails == null || self.mfContractDetails == undefined) {
        self.pdfSrc = '';
      } else {
        self.pdfSrc = row.scanCopy;
      }
    },
  },
};
</script>